<script setup>
import {useForm, usePage} from "@inertiajs/vue3"

const page = usePage()
const form = useForm({
    name: '',
    email: ''
})

const submitForm = () => {
    form.post(route('newsletter.subscribe'), {
        preserveScroll: true
    })
}
</script>

<template>
    <v-row>
        <v-col cols="12" class="align-start d-flex justify-start i-news">
            <p>Fique por dentro de nossas novidades!</p>
        </v-col>
        <v-col cols="12" class="d-flex justify-start i-news">
            <v-form ref="formRef" @submit.prevent="submitForm">
                <div class="d-flex ga-4 flex-wrap">
                    <v-text-field
                        v-model="form.name"
                        variant="underlined"
                        label="Seu nome"
                        :disabled="form.processing"
                        :error-messages="form.errors.name"
                        required
                        class="flex-grow-1 newsletter-field"
                    ></v-text-field>
                    <v-text-field
                        v-model="form.email"
                        variant="underlined"
                        type="email"
                        label="Seu melhor e-mail"
                        :disabled="form.processing"
                        :error-messages="form.errors.email"
                        required
                        class="flex-grow-1 newsletter-field"
                    ></v-text-field>
                    <v-btn
                        variant="outlined"
                        type="submit"
                        :loading="form.processing"
                        :disabled="form.processing"
                        class="flex-shrink-0 newsletter-btn"
                    >
                        {{ form.processing ? 'Enviando...' : 'Enviar' }}
                    </v-btn>
                </div>
            </v-form>
        </v-col>
    </v-row>
</template>

<style scoped>
.i-news p {
    font-size: 1.5rem;
    font-weight: bold;
    color: #fff;
}

.i-news .v-btn {
    border-radius: 25px !important;
}

.newsletter-field {
    min-width: 200px;
}

@media (min-width: 960px) {
    .newsletter-field {
        min-width: 300px;
    }
}

.newsletter-btn {
    margin-top: -8px;
}

@media (max-width: 599px) {
    .newsletter-btn {
        margin-top: 8px;
        width: 100%;
    }

    .i-news p {
        font-size: 1.2rem;
    }
}
</style>
